<template>
  <div class="star_banner_content_Right">
    <!--单选题-->
    <div class="star_banner_content_Right_top" v-if="currentObj.questionType=='selection'">
      <p class="font18 colorBlack" style="text-align: left; height: 45px; line-height: 45px;">
        <span :class="{'dui': currentObj.isCorrect=='1', 'cuo': currentObj.isCorrect=='0'}"></span>
        {{questionIdx+1}}.{{currentObj.questionInfoList.description}}<span class="colorBlue">（单选）</span>
      </p>
      <p class="font14 colorBlack displayFlex" v-for="item in currentObj.answerInfoList" :key="item.id">
        <input disabled type="radio" name="timu" :id="item.id" :value="item.no" v-model="answer" />
        <span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}
      </p>
    </div>
    <!--/单选题-->
    <!--多选题-->
    <div class="star_banner_content_Right_top" v-if="currentObj.questionType=='multiSelection'">
      <p class="font18 colorBlack" style="text-align: left; height: 45px; line-height: 45px;">
        <span :class="{'dui': currentObj.isCorrect=='1', 'cuo': currentObj.isCorrect=='0'}"></span>
        {{questionIdx+1}}.{{currentObj.questionInfoList.description}}<span class="colorBlue">（多选）</span>
      </p>
      <p class="font14 colorBlack displayFlex" v-for="item in currentObj.answerInfoList" :key="item.id">
        <input disabled type="checkbox" style="opacity: 1" name="timu" :id="item.id" :value="item.no" v-model="multiSelectionsAnswer"/>
        <span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}
      </p>
    </div>
    <!--/多选题-->
    <!--判断题-->
    <div class="star_banner_content_Right_top" v-if="currentObj.questionType=='judgement'">
      <p class="font18 colorBlack" style="text-align: left; height: 45px; line-height: 45px;">
        <span :class="{'dui': currentObj.isCorrect=='1', 'cuo': currentObj.isCorrect=='0'}"></span>
        {{questionIdx+1}}.{{currentObj.questionInfoList.description}}<span class="colorBlue">（判断）</span>
      </p>
      <p class="font14 colorBlack displayFlex" v-for="item in currentObj.answerInfoList" :key="item.id">
        <input disabled type="radio" name="timu" :id="item.id" :value="item.no" v-model="answer" />
        <span class="marginSpan">{{String.fromCharCode(65 + parseInt(item.no))}}.</span> {{item.description}}
      </p>
    </div>
    <!--/判断题-->
    <!--简答题-->
    <div class="star_banner_content_Right_top" v-if="currentObj.questionType=='short'">
      <p class="font18 colorBlack" style="text-align: left; height: 45px; line-height: 45px;">
        {{questionIdx+1}}.{{currentObj.questionInfoList.description}}<span class="colorBlue">（简答题）</span>
      </p>
      <textarea disabled class="text_con" placeholder="请输入您的答案" v-model="answer" style="width: 716px;"></textarea>
    </div>
    <!--/简答题-->
    <!--填空题-->
    <div class="star_banner_content_Right_top" v-show="currentObj.questionType=='write'">
      <p class="font18 colorBlack" style="text-align: left; height: 45px; line-height: 45px;">
        <span :class="{'dui': currentObj.isCorrect=='1', 'cuo': currentObj.isCorrect=='0'}"></span>
        {{questionIdx+1}}.
        <a id="write_description" style="color: #000;"></a>
        <span class="colorBlue">（填空题）</span></p>
    </div>
    <!--/填空题-->
    <div>
      <div class="shijuan_analysis">
        <div class="font14 colorGreen" v-if="currentObj.questionType=='short' || currentObj.questionType=='write'">正确答案：&nbsp;&nbsp;<span class="redColor" v-if="currentObj.answer">{{currentObj.answer}}</span><span class="redColor" v-if="!currentObj.answer">无</span></div>
        <div style="text-align: left;" class="font14 colorGreen" v-if="currentObj.questionType=='selection'">正确答案：&nbsp;&nbsp;<span class="redColor">{{String.fromCharCode(65 + parseInt(currentObj.answer))}}</span></div>
        <div style="text-align: left;" class="font14 colorGreen" v-if="currentObj.questionType=='judgement'">正确答案：&nbsp;&nbsp;<span class="redColor" v-if="currentObj.answer == '0'">正确</span><span class="redColor" v-if="currentObj.answer == '1'">错误</span></div>
        <div style="text-align: left;" class="font14 colorGreen" v-if="currentObj.questionType=='multiSelection'">正确答案：&nbsp;&nbsp;<span class="redColor">{{ AscToString(currentObj.answer) }}</span></div>
        <div style="text-align: left;" class="font12 colorBlack" v-if="currentObj.thinkingInfoList && currentObj.thinkingInfoList.description">解题思路： &nbsp;{{currentObj.thinkingInfoList.description}}</div>
        <img v-if="currentObj.thinkingInfoList && currentObj.thinkingInfoList.uri" :src="currentObj.thinkingInfoList.uri" alt="">
      </div>
    </div>
    <div class="star_banner_content_Right_bottom">
      <div style="display: flex; flex-direction: row;align-items: center;">
        得分:&nbsp;&nbsp;
        <span v-if="result.isPassed == '1'" style="color: green;">{{result.score}}</span>
        <span v-if="result.isPassed == '0'" style="color: red;">{{result.score}}</span> / {{result.paperScore}}
      </div>
      <div style="display: flex;flex-direction: row;align-items: center;">
        <a href="javascript:;" class="star_banner_content_Right_bottom_a" v-if="questionIdx > 0" @click="toSwitch('prev')">上一题</a>
        <a href="javascript:;" class="star_banner_content_Right_bottom_a" v-if="questionIdx < cnt - 1" @click="toSwitch('next')">下一题</a>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        name: "quiz",
        props: ['question', 'cnt', 'result'],
        data () {
          return {
            questionIdx: 0,
            currentObj: {},
            answer: '', // 单选题、判断题、简单题答案
            multiSelectionsAnswer: [] //  多选题答案
          }
        },
        mounted () {
          this.currentObj = $.extend(true, {}, this.question); // 深复制对象
          if (this.currentObj.questionType == 'write') {
            this.createWriteQ(this.currentObj.questionInfoList.description)
          }
          this.setAnswer(this.currentObj.questionType, this.currentObj.infoAnswer) // 重新赋值答案
        },
        watch: {
          question (val) { // 处理父级组件向内传输的值
            this.currentObj = $.extend(true, {}, val); // 深复制对象
            this.answer = ''
            this.multiSelectionsAnswer = []
            if (this.currentObj.questionType == 'write') {
              this.createWriteQ(this.currentObj.questionInfoList.description, this.currentObj.infoAnswer)
            }
            this.setAnswer(this.currentObj.questionType, this.currentObj.infoAnswer) // 重新赋值答案
          }
        },
        methods: {
          AscToString (arr) {
            var answerStr = ''
            var arr_sort = arr.slice(0)
            for (let i=0; i<arr_sort.length; i++) {
              answerStr += String.fromCharCode(65 + parseInt(arr_sort[i])) + ','
            }
            answerStr = answerStr.substring(0, answerStr.length - 1) // 去掉最后的逗号
            return answerStr
          },
          setAnswer (type, raws) {
            switch (type) {
              case 'multiSelection':
                this.multiSelectionsAnswer = raws.split('');
                break;
              default:
                this.answer = raws
            }
          },
          dealAnswers (type, raws) { // 处理向外发送的数据
            function sortNumber (a, b) {
              return a - b;
            }
            switch (type) {
              case 'multiSelection':
                raws.sort(sortNumber);
                if (raws && raws.length>0) {
                  let multiSelectStr = ''
                  for (let i=0; i < raws.length; i++) {
                    multiSelectStr += raws[i]
                  }
                  return multiSelectStr
                } else {
                  return ''
                }
              case 'write':
                return this.inputValueDeal('#write_description').inputstr
              default:
                return raws
            }
          },
          inputValueDeal (id) { // 生成填空题答案
            var allInputs = $(id).find('.tktext')
            var inputsValue = [];
            var result = {};
            for (let i = 0; i < allInputs.length; i++) {
              inputsValue.push($(allInputs[i]).val());
            }
            for (let j = 0; j < allInputs.length; j++) {
              $(allInputs[j]).after(inputsValue[j]);
            }
            for (let k = 0; k < inputsValue.length; k++) {
              if (inputsValue[k] == '') {
                result.isNull = true;
                break;
              } else {
                result.isNull = false;
              }
            }
            $(id).find('.tktext').remove();
            result.inputstr = $(id).html();
            return result;
          },
          createWriteQ (writeStr, answer) { // 生成填空题（包含答案的话传answer参数）
            var replaceStr = '(<input type="text" disabled class="tktext" value=""/>)'
            $('#write_description').html(this.$utils.bracketReplace(writeStr, replaceStr));
            if (answer && answer !='') {
              var answerList = this.$utils.bracketText(answer);
              for (let i = 0; i < answerList.length; i++) {
                $('#write_description').find('.tktext')[i].value = answerList[i];
              }
            }
          },
          getAnswer () { // 生成最后提交给外部的数据
            var answer;
            if (this.question.questionType == 'multiSelection') {
              answer = this.dealAnswers(this.question.questionType, this.multiSelectionsAnswer)
            } else {
              answer = this.dealAnswers(this.question.questionType, this.answer)
            }
            return answer
          },
          toSwitch (type) { // 向父级组件传播事件和值
            if (type=='prev') {
              this.questionIdx = this.questionIdx - 1
            } else if (type=='next') {
              this.questionIdx = this.questionIdx + 1
            }
            var answer = this.getAnswer()
            this.toOuter('switch-question', {nextIdx: this.questionIdx, currentQ: this.question, answer: answer, isFinish: '0'})
          },
          toOuter (event, params) {
            this.$emit(event, params)
          }
        }
    }
</script>

<style scoped>
  .star_banner_content_Right { height: auto; }
  .star_banner_content_Right_top { padding-bottom: 15px; height: auto; }
  .star_banner_content_Right_bottom_a:hover { color: #E72B12; }
  .star_banner_get { display: block; width: 104px; height: 34px; color: white; text-decoration: none; }
</style>



// WEBPACK FOOTER //
// src/page/modules/exam/quizresult.vue